module.exports = __webpack_public_path__ + "assets/static/png/zsu-logo.084c9ee71a4f682255bff1b142e091c1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/serviceReceipt/images/zsu-logo.png
 ** module id = 533
 ** module chunks = 1
 **/